import { useTranslation } from "react-i18next";
import type { ValidationSchema } from "../../types";
import styles from "./styles.module.css";

interface Props {
  validationData: ValidationSchema;
}

export const AuthErrorMessage = ({ validationData }: Props) => {
  const { t } = useTranslation();

  if (validationData.username) {
    return <p className={styles.error}>{t("login.error_no_username")}</p>;
  }
  if (validationData.password) {
    return <p className={styles.error}>{t("login.error_no_password")}</p>;
  }
  if (validationData.credentials) {
    return (
      <p className={styles.error}>{t("login.error_incorrect_credentials")}</p>
    );
  }
};
